/** Uso contínuo é definido por medicamento; a receita herda se algum item tiver a flag. */
export function prescriptionHasContinuousUse(
  prescription: {
    is_continuous_use?: boolean | null;
    items?: Array<{ is_continuous_use?: boolean | null }> | null;
  } | null | undefined,
): boolean {
  if (Boolean(prescription?.is_continuous_use)) return true;
  return (prescription?.items || []).some((item) => Boolean(item?.is_continuous_use));
}

export function itemsHaveContinuousUse(
  items: Array<{ is_continuous_use?: boolean | null }> | null | undefined,
): boolean {
  return (items || []).some((item) => Boolean(item?.is_continuous_use));
}
